/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchFirestoreDocument } from "utility/firebase";
import { Store } from "../../store";
import { useVideoAuthenticator } from "hooks/video/VideoAuthenticator";
import { LoaderLayout } from "components/atoms/loader/LoaderLayout";
import { streamingActions } from "modules/streaming";
import { VideoErrorBehavior } from "./VideoErrorBehavior";
import { StreamingSwitcher } from "containers/streaming/StreamingSwitcher";

/**
 * `/videos/{videoId}` routing component
 * created based on StreamingTicketAuthenticator
 * @returns
 */
export const VideoBase = () => {
  const isDarkModeEnabled = useSelector(
    (state: Store) => state.streaming.streamingSettings.isDarkModeEnabled
  );
  const [vodSetting, setVodSetting] = useState(null);
  const [liveSetting, setLiveSetting] = useState(null);

  const dispatch = useDispatch();

  const { video, displayEvent, streamingKey, eventVideoMap, error } =
    useVideoAuthenticator();

  useEffect(() => {
    getPlayerSettings();
    dispatch(streamingActions.createMySmallIconUrl.started());
    return () => {};
  }, [dispatch]);

  const getPlayerSettings = async () => {
    // @ts-expect-error TS2345
    setVodSetting(await fetchFirestoreDocument(`/THEOSettings/VOD`));
    // @ts-expect-error TS2345
    setLiveSetting(await fetchFirestoreDocument(`/THEOSettings/Live`));
  };

  if (displayEvent && error) {
    return <VideoErrorBehavior displayEvent={displayEvent} error={error} />;
  }

  if (
    !video ||
    !displayEvent ||
    !streamingKey ||
    !eventVideoMap ||
    !vodSetting ||
    !liveSetting
  ) {
    return (
      <div id="contents-layout">
        <LoaderLayout />
      </div>
    );
  }

  return (
    <StreamingSwitcher
      url={""}
      // @ts-expect-error TS2322
      cookies={streamingKey.cookies}
      cookiesList={streamingKey.cookiesList}
      event={displayEvent}
      // @ts-expect-error TS2322
      hasTicket={streamingKey.hasTickets}
      // @ts-expect-error TS2322
      vid={video._id}
      eventVideoMap={eventVideoMap}
      vodSetting={vodSetting}
      liveSetting={liveSetting}
      isDarkModeEnabled={isDarkModeEnabled}
    />
  );
};
